import { useCallback, useState } from 'react';

import { getBalanceBuyerPortalUrl, getBalanceVendorOnboardingUrl } from 'utils/api/companies';

function useBalanceRedirect(fetchUrl: () => Promise<{ url: string }>) {
  const [isRedirecting, setIsRedirecting] = useState(false);

  const open = useCallback(async () => {
    setIsRedirecting(true);
    try {
      const data = await fetchUrl();
      if (data?.url && typeof window !== 'undefined') {
        window.location.assign(data.url);
      } else {
        setIsRedirecting(false);
        throw new Error('No URL returned');
      }
    } catch (err) {
      setIsRedirecting(false);
      throw err;
    }
  }, [fetchUrl]);

  return { open, isRedirecting };
}

export function useBalanceBuyerPortal() {
  const { open, isRedirecting } = useBalanceRedirect(getBalanceBuyerPortalUrl);
  return { openPortal: open, isRedirecting };
}

export function useBalanceVendorOnboarding() {
  const { open, isRedirecting } = useBalanceRedirect(getBalanceVendorOnboardingUrl);
  return { openOnboarding: open, isRedirecting };
}
